import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap, filter } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { UPDATE_FIELD } from '../../release/actions';
import { UpdateField } from '@webapp/store/release/action-creators';
import { trackList } from '@webapp/store/tracks/selectors';
import { UpdateTrackField } from '../action-creators';

/**
 *
 * This effect updates Tracks' titles for a SINGLE
 *
 */

export const updateTrackTitleEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, UpdateField<'title'>>(UPDATE_FIELD),
    withLatestFrom(state$),
    filter(([action, state]) => state.release.release?.type === 'single' && action.field === 'title'),
    concatMap(([_, state]) => {

      const release = state.release.release;
      const tracks = trackList(state.tracks.tracks, release?.id);

      if (tracks.length > 1) {
        return [];
      }

      return tracks.map((track) => new UpdateTrackField<'title'>(track.id as string, 'title', release?.title || track.title || ''));
    })
  );